export const commaToDot = (val) => {
  return val.replace(/,/g, '.');
}
